import React, { Fragment, useState } from 'react';
import { useTranslation } from 'react-i18next';
import classNames from 'classnames';

import { Accordion } from 'formlabs-web-components/Media';
import { Header } from 'formlabs-web-components/Type';

import Filter from '../../filtering/Filter';

import './Filters.module.css';
import useIsMobile from '../../../hooks/useIsMobile';
import useFetchFilter from '../../../hooks/useFetchFilter';

const Filters = ({
  availableFilters,
  activeFilterCount,
  filters,
  updateFilterAction,
  resetFilterAction,
  storeId,
  children
}) => {
  const { t } = useTranslation();
  const [overlayShowing, setOverlayShowing] = useState(false);

  const isMobile = useIsMobile(640);

  return (
    <Fragment>
      {isMobile && (
        <button
          styleName="open-filters"
          style={{ marginRight: '0rem' }}
          onClick={() => setOverlayShowing(!overlayShowing)}
        >
          <i className="fl-filter" />{' '}
          <span style={{ marginLeft: '1rem' }}>{t('Filter')}</span>
        </button>
      )}

      {!isMobile && (
        <div styleName="headline">
          <span>{t('Filter')}</span>
          <span>|</span>
          <button onClick={resetFilterAction}>
            {t('Reset ({{activeFilterCount}})', { activeFilterCount })}
          </button>
        </div>
      )}

      <div
        styleName={classNames({
          'overlay-open': overlayShowing,
          'overlay-closed': !overlayShowing
        })}
      >
        {isMobile && (
          <Header level={2} displayAs={4} weight={700}>
            {t('Filter')}
          </Header>
        )}
        {overlayShowing && children ? children : null}

        <Accordion type="filter-list">
          {availableFilters.map(filterId => (
            <Filter
              key={filterId}
              id={filterId}
              activeOptions={filters[filterId]}
              updateFilter={updateFilterAction}
              storeId={storeId}
              structure={() => useFetchFilter(filterId, storeId)}
              updateUrlParams={true}
            />
          ))}
        </Accordion>

        {isMobile && (
          <div styleName="open-filters bottom">
            <button styleName="reset" onClick={resetFilterAction}>
              {t('Reset ({{activeFilterCount}})', { activeFilterCount })}
            </button>

            <button
              styleName="doneBtn"
              onClick={() => setOverlayShowing(false)}
            >
              {t('Done')}
            </button>
          </div>
        )}
      </div>
    </Fragment>
  );
};

export default Filters;
